<div *ngIf="!isArtifact" class="landing-page relative min-h-screen h-[100vh] overflow-y-auto bg-[#070710] text-white antialiased selection:bg-purple-500/30">

  <!-- Ambient background: grid + glow blobs -->
  <div class="pointer-events-none fixed inset-0 z-0 overflow-hidden">
    <div class="absolute inset-0 opacity-[0.07]"
         style="background-image:linear-gradient(to right, rgba(255,255,255,0.5) 1px, transparent 1px),linear-gradient(to bottom, rgba(255,255,255,0.5) 1px, transparent 1px);background-size:48px 48px;"></div>
    <div class="zavo-blob absolute -top-32 -left-24 h-[420px] w-[420px] rounded-full bg-orange-500/20 blur-[120px]"></div>
    <div class="zavo-blob absolute top-1/3 -right-24 h-[460px] w-[460px] rounded-full bg-purple-600/20 blur-[130px]" style="animation-delay:-4s;"></div>
    <div class="zavo-blob absolute bottom-0 left-1/3 h-[380px] w-[380px] rounded-full bg-indigo-600/20 blur-[120px]" style="animation-delay:-8s;"></div>
  </div>

  <!-- Header Navigation -->
  <header class="fixed w-full top-0 z-40 backdrop-blur-xl bg-[#070710]/70 border-b border-white/[0.06]">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center py-4">
        <div class="flex items-center gap-3">
          <svg viewBox="0 0 66 43" class="h-7 w-7" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="zavoLogoGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stop-color="#f97316"/>
                <stop offset="55%" stop-color="#a855f7"/>
                <stop offset="100%" stop-color="#6366f1"/>
              </linearGradient>
            </defs>
            <path fill="url(#zavoLogoGrad)" d="M65.07 19.296a3.074 3.074 0 0 1 0 4.414l-3.8 3.74-3.599 3.536-11.999 11.808a.636.636 0 0 1-.456.187H15.947a.64.64 0 0 1-.603-.386.614.614 0 0 1 .154-.692l4.726-4.651 2.534-2.494a.633.633 0 0 1 .456-.187h18.372a.642.642 0 0 0 .456-.187l3.427-3.373 7.419-7.295a3.074 3.074 0 0 0 0-4.414L42.105 8.63a.634.634 0 0 0-.456-.187h-8.635a.64.64 0 0 1-.603-.387.614.614 0 0 1 .154-.692l4.13-4.059L39.863.187A.634.634 0 0 1 40.319 0h4.884a.643.643 0 0 1 .456.187l19.411 19.11Z"/>
            <path fill="url(#zavoLogoGrad)" d="m34.812 1.117-7.248 7.132a.67.67 0 0 1-.468.194h-6.209a.642.642 0 0 0-.468.17.624.624 0 0 0-.197.453v23.878c0 .174-.072.34-.197.462l-.424.418-6.823 6.714a.634.634 0 0 1-.749.202.63.63 0 0 1-.308-.267.615.615 0 0 1-.077-.396V9.097a.615.615 0 0 0-.197-.452.636.636 0 0 0-.468-.171H.665a.643.643 0 0 1-.468-.172A.623.623 0 0 1 0 7.85V.655A.615.615 0 0 1 .197.203.635.635 0 0 1 .665.032h33.697a.641.641 0 0 1 .61.387.614.614 0 0 1-.16.698Z"/>
          </svg>
          <div class="leading-none">
            <div class="text-xl font-bold tracking-tight zavo-gradient-text">Zavo</div>
            <div class="text-[11px] text-slate-400 font-medium mt-0.5">AI App Builder</div>
          </div>
        </div>

        <button
          (click)="loginFlagToggle()"
          class="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white/[0.06] border border-white/[0.1] text-sm font-semibold text-white hover:bg-white/[0.12] hover:border-white/20 transition-all duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
          </svg>
          Sign In
        </button>
      </div>
    </div>
  </header>

  <!-- Hero Section -->
  <section class="relative z-10 pt-36 pb-24 md:pt-44 md:pb-32">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-4xl mx-auto text-center">
        <div class="inline-flex items-center gap-2 px-3.5 py-1.5 mb-7 rounded-full bg-white/[0.04] border border-white/[0.1] text-xs font-medium text-slate-300">
          <span class="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse"></span>
          Build internal tools &amp; apps with AI
        </div>
        <h1 class="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-[1.1] tracking-tight mb-6">
          Ship software at the speed of
          <span class="zavo-gradient-text">thought</span>
        </h1>
        <p class="text-lg sm:text-xl text-slate-400 mb-10 max-w-2xl mx-auto leading-relaxed">
          Zavo turns a prompt into a working app — visual pages, real data models, and
          automated logic. No boilerplate. No DevOps. Just describe it and build.
        </p>
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            (click)="loginFlagToggle()"
            class="px-8 py-4 rounded-xl font-bold text-white shadow-lg shadow-purple-900/30 bg-gradient-to-r from-orange-500 via-purple-500 to-indigo-500 hover:opacity-90 transition-all duration-300 transform hover:scale-[1.03]">
            Get Started Free
          </button>
          <button
            (click)="loginFlagToggle()"
            class="px-8 py-4 rounded-xl font-bold text-white bg-white/[0.05] border border-white/[0.12] hover:bg-white/[0.1] transition-all duration-300">
            Sign In to Workspace
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="relative z-10 py-20">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16">
        <h2 class="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Everything you need to build</h2>
        <p class="text-lg text-slate-400 max-w-2xl mx-auto">
          One platform from idea to production — design, data, logic and automation in a single workspace.
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <!-- AI Page Builder -->
        <div class="zavo-card rounded-2xl p-7 bg-white/[0.03] border border-white/[0.08]">
          <div class="w-12 h-12 rounded-xl bg-orange-500/15 flex items-center justify-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-orange-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
          </div>
          <h3 class="text-lg font-bold mb-2">AI Page Builder</h3>
          <p class="text-slate-400 text-sm leading-relaxed">
            Describe the screen you want and watch Zavo generate the layout, components and bindings in seconds.
          </p>
        </div>

        <!-- Visual Editor -->
        <div class="zavo-card rounded-2xl p-7 bg-white/[0.03] border border-white/[0.08]">
          <div class="w-12 h-12 rounded-xl bg-purple-500/15 flex items-center justify-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v4H4V5zM4 11h7v9H5a1 1 0 01-1-1v-8zM13 11h7v8a1 1 0 01-1 1h-6v-9z" />
            </svg>
          </div>
          <h3 class="text-lg font-bold mb-2">Visual Editor</h3>
          <p class="text-slate-400 text-sm leading-relaxed">
            Drag, drop and fine-tune every pixel. A live designer with full control over layout, style and spacing.
          </p>
        </div>

        <!-- Function Builder -->
        <div class="zavo-card rounded-2xl p-7 bg-white/[0.03] border border-white/[0.08]">
          <div class="w-12 h-12 rounded-xl bg-indigo-500/15 flex items-center justify-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
          </div>
          <h3 class="text-lg font-bold mb-2">Function Builder</h3>
          <p class="text-slate-400 text-sm leading-relaxed">
            Compose business logic visually with blocks that compile to clean code — no syntax to memorise.
          </p>
        </div>

        <!-- Data & Entities -->
        <div class="zavo-card rounded-2xl p-7 bg-white/[0.03] border border-white/[0.08]">
          <div class="w-12 h-12 rounded-xl bg-emerald-500/15 flex items-center justify-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 7c0-1.657 3.582-3 8-3s8 1.343 8 3-3.582 3-8 3-8-1.343-8-3zM4 7v10c0 1.657 3.582 3 8 3s8-1.343 8-3V7M4 12c0 1.657 3.582 3 8 3s8-1.343 8-3" />
            </svg>
          </div>
          <h3 class="text-lg font-bold mb-2">Data &amp; Entities</h3>
          <p class="text-slate-400 text-sm leading-relaxed">
            Model your tables, fields and relationships — Zavo provisions a real database behind the scenes.
          </p>
        </div>

        <!-- Workflows -->
        <div class="zavo-card rounded-2xl p-7 bg-white/[0.03] border border-white/[0.08]">
          <div class="w-12 h-12 rounded-xl bg-rose-500/15 flex items-center justify-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-rose-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <circle cx="5" cy="6" r="2"></circle><circle cx="19" cy="6" r="2"></circle><circle cx="12" cy="18" r="2"></circle>
              <path stroke-linecap="round" d="M7 6h10M6.5 7.5L11 16.5M17.5 7.5L13 16.5"></path>
            </svg>
          </div>
          <h3 class="text-lg font-bold mb-2">Workflows &amp; Automation</h3>
          <p class="text-slate-400 text-sm leading-relaxed">
            Connect triggers, integrations and scheduled jobs to run your processes automatically.
          </p>
        </div>

        <!-- Multi-tenant / Roles -->
        <div class="zavo-card rounded-2xl p-7 bg-white/[0.03] border border-white/[0.08]">
          <div class="w-12 h-12 rounded-xl bg-sky-500/15 flex items-center justify-center mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-sky-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <h3 class="text-lg font-bold mb-2">Roles &amp; Teams</h3>
          <p class="text-slate-400 text-sm leading-relaxed">
            Built-in users, roles and granular permissions so every team works in its own secure space.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="relative z-10 py-20">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="relative overflow-hidden rounded-3xl border border-white/[0.08] bg-gradient-to-br from-purple-600/20 via-indigo-600/10 to-orange-500/20 px-8 py-14 md:px-14 text-center">
        <div class="relative z-10 max-w-2xl mx-auto">
          <h2 class="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Start building today</h2>
          <p class="text-lg text-slate-300 mb-9">
            Spin up your first app in minutes. No credit card, no setup — just sign in and create.
          </p>
          <button
            (click)="loginFlagToggle()"
            class="px-8 py-4 rounded-xl font-bold text-white shadow-lg shadow-purple-900/30 bg-gradient-to-r from-orange-500 via-purple-500 to-indigo-500 hover:opacity-90 transition-all duration-300 transform hover:scale-[1.03]">
            Launch Your Workspace
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="relative z-10 border-t border-white/[0.06] py-10">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex items-center gap-2.5">
          <svg viewBox="0 0 66 43" class="h-5 w-5" xmlns="http://www.w3.org/2000/svg">
            <path fill="url(#zavoLogoGrad)" d="M65.07 19.296a3.074 3.074 0 0 1 0 4.414l-3.8 3.74-3.599 3.536-11.999 11.808a.636.636 0 0 1-.456.187H15.947a.64.64 0 0 1-.603-.386.614.614 0 0 1 .154-.692l4.726-4.651 2.534-2.494a.633.633 0 0 1 .456-.187h18.372a.642.642 0 0 0 .456-.187l3.427-3.373 7.419-7.295a3.074 3.074 0 0 0 0-4.414L42.105 8.63a.634.634 0 0 0-.456-.187h-8.635a.64.64 0 0 1-.603-.387.614.614 0 0 1 .154-.692l4.13-4.059L39.863.187A.634.634 0 0 1 40.319 0h4.884a.643.643 0 0 1 .456.187l19.411 19.11Z"/>
          </svg>
          <span class="text-sm font-semibold text-slate-300">Zavo</span>
        </div>
        <p class="text-sm text-slate-500">© 2026 Zavo. All rights reserved.</p>
        <div class="flex items-center gap-5">
          <a href="#" class="text-slate-500 hover:text-white transition-colors text-sm">Privacy</a>
          <a href="#" class="text-slate-500 hover:text-white transition-colors text-sm">Terms</a>
          <a href="#" class="text-slate-500 hover:text-white transition-colors text-sm">Docs</a>
        </div>
      </div>
    </div>
  </footer>

  <!-- ═══════════════ Login Modal ═══════════════ -->
  <div *ngIf="loginFlag" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="login-modal" role="dialog" aria-modal="true">
    <div class="flex flex-col justify-center items-center min-h-[100vh] bg-black/80 backdrop-blur-sm px-4 py-8">

      <!-- Modal panel -->
      <div class="zavo-modal relative w-full max-w-md rounded-2xl overflow-hidden border border-white/[0.1] bg-[#0d0d18] shadow-2xl">

        <!-- Header with gradient -->
        <div class="relative px-6 py-7 bg-gradient-to-r from-orange-500/90 via-purple-600/90 to-indigo-600/90">
          <button type="button"
            class="absolute top-4 right-4 text-white/80 hover:text-white transition-colors cursor-pointer"
            (click)="exitScreen()">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <div class="flex items-center gap-3.5">
            <div class="h-11 w-11 rounded-xl bg-white/15 backdrop-blur flex items-center justify-center">
              <svg viewBox="0 0 66 43" class="h-6 w-6" xmlns="http://www.w3.org/2000/svg">
                <path fill="#ffffff" d="M65.07 19.296a3.074 3.074 0 0 1 0 4.414l-3.8 3.74-3.599 3.536-11.999 11.808a.636.636 0 0 1-.456.187H15.947a.64.64 0 0 1-.603-.386.614.614 0 0 1 .154-.692l4.726-4.651 2.534-2.494a.633.633 0 0 1 .456-.187h18.372a.642.642 0 0 0 .456-.187l3.427-3.373 7.419-7.295a3.074 3.074 0 0 0 0-4.414L42.105 8.63a.634.634 0 0 0-.456-.187h-8.635a.64.64 0 0 1-.603-.387.614.614 0 0 1 .154-.692l4.13-4.059L39.863.187A.634.634 0 0 1 40.319 0h4.884a.643.643 0 0 1 .456.187l19.411 19.11Z"/>
                <path fill="#ffffff" d="m34.812 1.117-7.248 7.132a.67.67 0 0 1-.468.194h-6.209a.642.642 0 0 0-.468.17.624.624 0 0 0-.197.453v23.878c0 .174-.072.34-.197.462l-.424.418-6.823 6.714a.634.634 0 0 1-.749.202.63.63 0 0 1-.308-.267.615.615 0 0 1-.077-.396V9.097a.615.615 0 0 0-.197-.452.636.636 0 0 0-.468-.171H.665a.643.643 0 0 1-.468-.172A.623.623 0 0 1 0 7.85V.655A.615.615 0 0 1 .197.203.635.635 0 0 1 .665.032h33.697a.641.641 0 0 1 .61.387.614.614 0 0 1-.16.698Z"/>
              </svg>
            </div>
            <div>
              <h3 class="text-xl font-bold text-white">Welcome to Zavo</h3>
              <p class="text-sm text-white/80">Sign in to your workspace</p>
            </div>
          </div>
        </div>

        <!-- Login Form -->
        <div *ngIf="!forgotPasswordFlag" class="px-6 py-7">
          <!-- Mode Switch (Email / Phone) -->
          <div class="mb-6">
            <div class="inline-flex w-full rounded-xl bg-white/[0.05] border border-white/[0.08] p-1">
              <button
                type="button"
                (click)="switchLoginMode('email')"
                class="w-1/2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors"
                [ngClass]="loginMode === 'email' ? 'bg-white/10 text-white shadow' : 'text-slate-400 hover:text-white'">
                Email
              </button>
              <button
                type="button"
                (click)="switchLoginMode('phone')"
                class="w-1/2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors"
                [ngClass]="loginMode === 'phone' ? 'bg-white/10 text-white shadow' : 'text-slate-400 hover:text-white'">
                Phone
              </button>
            </div>
          </div>

          <!-- Email mode -->
          <div class="space-y-5" *ngIf="loginMode === 'email'">
            <div>
              <label for="email" class="block text-sm font-medium text-slate-300 mb-1.5">Email Address</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                  </svg>
                </div>
                <input
                  type="email"
                  id="email"
                  name="email"
                  [(ngModel)]="emailId"
                  (ngModelChange)="loginError=''"
                  (keyup.enter)="login()"
                  class="block w-full pl-10 pr-3 py-3 rounded-xl bg-white/[0.04] border border-white/[0.1] text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-purple-500/60 focus:border-purple-500/60 transition-colors"
                  placeholder="Enter your email address"
                />
              </div>
            </div>

            <div>
              <label for="password" class="block text-sm font-medium text-slate-300 mb-1.5">Password</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <input
                  type="password"
                  id="passwordInput"
                  name="password"
                  [(ngModel)]="password"
                  (ngModelChange)="loginError=''"
                  (keyup.enter)="login()"
                  class="block w-full pl-10 pr-10 py-3 rounded-xl bg-white/[0.04] border border-white/[0.1] text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-purple-500/60 focus:border-purple-500/60 transition-colors"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                  (click)="togglePasswordVisibility()"
                  id="eyeIcon">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>

            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  [(ngModel)]="deliveryAddressCheckBoxFlag"
                  class="h-4 w-4 rounded bg-white/[0.04] border-white/20 text-purple-500 focus:ring-purple-500/60 transition-colors"
                />
                <label for="remember-me" class="ml-2 block text-sm text-slate-300">Remember me</label>
              </div>

              <div class="text-sm">
                <a href="#" (click)="forgotPassword(); $event.preventDefault()" class="font-medium text-purple-400 hover:text-purple-300 transition-colors">
                  Forgot password?
                </a>
              </div>
            </div>

            <!-- Single-session sign-out notice (kicked because the account signed in elsewhere) -->
            <div *ngIf="kickedNotice"
                 class="flex items-start gap-2 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-amber-200">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
              </svg>
              <div class="flex-1">
                <p class="font-medium text-amber-100">You were signed out</p>
                <p class="mt-0.5 leading-relaxed">Your account was signed in somewhere else — only one session is allowed at a time. If this wasn’t you, change your password and sign in again. Signing in here again will end that other session.</p>
              </div>
              <button type="button" (click)="kickedNotice=false" class="flex-shrink-0 text-amber-300/70 hover:text-amber-200" aria-label="Dismiss">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
            </div>

            <!-- Sign-in error -->
            <div *ngIf="loginError"
                 class="flex items-start gap-2 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 flex-shrink-0 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
              </svg>
              <span>{{ loginError }}</span>
            </div>

            <div>
              <button
                type="submit"
                (click)="login()"
                [disabled]="isLoggingIn"
                class="w-full flex justify-center items-center py-3 px-4 rounded-xl shadow-lg shadow-purple-900/30 text-sm font-semibold text-white bg-gradient-to-r from-orange-500 via-purple-500 to-indigo-500 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0d0d18] focus:ring-purple-500 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                </svg>
                {{ isLoggingIn ? 'Signing in…' : 'Sign in to your account' }}
              </button>
            </div>
          </div>

          <!-- Phone OTP mode -->
          <div class="space-y-5" *ngIf="loginMode === 'phone'">
            <div>
              <label for="phone" class="block text-sm font-medium text-slate-300 mb-1.5">Phone Number (E.164)</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  [(ngModel)]="phoneNumber"
                  class="block w-full pl-10 pr-3 py-3 rounded-xl bg-white/[0.04] border border-white/[0.1] text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-purple-500/60 focus:border-purple-500/60 transition-colors"
                  placeholder="e.g. +14155552671"
                />
              </div>
              <p class="mt-1.5 text-xs text-slate-500">Use the phone number configured by your admin.</p>
            </div>

            <!-- Invisible reCAPTCHA container (required by Firebase Phone Auth) -->
            <div id="recaptcha-container" class="h-0 overflow-hidden"></div>

            <div>
              <button
                type="button"
                (click)="sendOtp()"
                [disabled]="isSendingOtp"
                class="w-full flex justify-center py-3 px-4 rounded-xl shadow-lg shadow-purple-900/30 text-sm font-semibold text-white bg-gradient-to-r from-orange-500 via-purple-500 to-indigo-500 hover:opacity-90 disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0d0d18] focus:ring-purple-500 transition-all duration-200 transform hover:scale-[1.02]">
                {{ isSendingOtp ? 'Sending OTP...' : (otpSent ? 'Resend OTP' : 'Send OTP') }}
              </button>
            </div>

            <div *ngIf="otpSent">
              <label for="otp" class="block text-sm font-medium text-slate-300 mb-1.5">OTP Code</label>
              <input
                type="text"
                id="otp"
                name="otp"
                [(ngModel)]="otpCode"
                class="block w-full px-3 py-3 rounded-xl bg-white/[0.04] border border-white/[0.1] text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-purple-500/60 focus:border-purple-500/60 transition-colors"
                placeholder="Enter the code"
              />
            </div>

            <div *ngIf="otpSent">
              <button
                type="button"
                (click)="verifyOtp()"
                [disabled]="isVerifyingOtp"
                class="w-full flex justify-center py-3 px-4 rounded-xl shadow-lg shadow-purple-900/30 text-sm font-semibold text-white bg-gradient-to-r from-orange-500 via-purple-500 to-indigo-500 hover:opacity-90 disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0d0d18] focus:ring-purple-500 transition-all duration-200 transform hover:scale-[1.02]">
                {{ isVerifyingOtp ? 'Verifying...' : 'Verify & Sign In' }}
              </button>
            </div>
          </div>

          <div class="mt-6 flex justify-center">
            <span class="text-slate-500 text-xs">Secure login powered by Zavo</span>
          </div>
        </div>

        <!-- Forgot Password Form -->
        <div *ngIf="forgotPasswordFlag" class="px-6 py-7">
          <div class="space-y-5">
            <div class="text-center mb-4">
              <div class="w-16 h-16 rounded-2xl bg-purple-500/15 flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
              </div>
              <h3 class="text-xl font-bold text-white">Reset Your Password</h3>
              <p class="text-slate-400 mt-1 text-sm">We'll send you instructions to reset your password</p>
            </div>

            <div>
              <label for="forgot-email" class="block text-sm font-medium text-slate-300 mb-1.5">Email Address</label>
              <div class="relative">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                  </svg>
                </div>
                <input
                  type="email"
                  id="forgot-email"
                  name="forgot-email"
                  [(ngModel)]="forgotEmailId"
                  class="block w-full pl-10 pr-3 py-3 rounded-xl bg-white/[0.04] border border-white/[0.1] text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-purple-500/60 focus:border-purple-500/60 transition-colors"
                  placeholder="Enter your email address"
                />
              </div>
            </div>

            <div *ngIf="forgotError" class="text-sm text-red-400">{{ forgotError }}</div>
            <div *ngIf="forgotMessage" class="text-sm text-emerald-400">{{ forgotMessage }}</div>

            <div>
              <button
                type="button"
                (click)="resetPassword()"
                [disabled]="isSendingReset"
                class="w-full flex justify-center items-center py-3 px-4 rounded-xl shadow-lg shadow-purple-900/30 text-sm font-semibold text-white bg-gradient-to-r from-orange-500 via-purple-500 to-indigo-500 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0d0d18] focus:ring-purple-500 transition-all duration-200 transform hover:scale-[1.02] disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z" clip-rule="evenodd" />
                </svg>
                {{ isSendingReset ? 'Sending…' : 'Send Reset Link' }}
              </button>
            </div>

            <div class="text-center pt-2">
              <button
                type="button"
                (click)="forgotPasswordBack()"
                class="inline-flex items-center text-sm font-medium text-purple-400 hover:text-purple-300 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                </svg>
                Back to login
              </button>
            </div>
          </div>
        </div>

        <!-- Modal footer with security badge -->
        <div class="px-6 py-4 border-t border-white/[0.06] bg-white/[0.02]">
          <div class="flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-emerald-400 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
            <span class="text-sm text-slate-400">Enterprise-grade security &amp; encryption</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
